var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { getFetchWrapper } from "@syf-api-library/core";
import { useQuery } from "@tanstack/react-query";
import { CARD_ACTIVATION_ELIGIBILITY_URL } from "../../const/endpoints";
import { CardActivationCacheKey, } from "./useCardActivation.types";
var getCardActivationData = function (config, keyProps) {
    var fetchWrapper = getFetchWrapper(config);
    return function () {
        var params = new URLSearchParams({
            "cipher.accountId": keyProps.accountId,
        });
        if (keyProps.accountIdType) {
            params.set("accountIdType", keyProps.accountIdType);
        }
        return fetchWrapper("".concat(CARD_ACTIVATION_ELIGIBILITY_URL, "?").concat(params), {
            method: "GET",
        });
    };
};
export function useCardActivationQuery(_a) {
    var config = _a.config, keyProps = _a.keyProps, _b = _a.queryOptions, queryOptions = _b === void 0 ? {} : _b;
    return useQuery(__assign({ queryKey: CardActivationCacheKey(keyProps), queryFn: getCardActivationData(config, keyProps) }, queryOptions));
}
//# sourceMappingURL=useCardActivationQuery.js.map